export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType[AuthTokenType["EditorLowPrivilege"] = 0] = "EditorLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopLowPrivilege"] = 1] = "AugLoopLowPrivilege";
    AuthTokenType[AuthTokenType["Anonymous"] = 2] = "Anonymous";
    AuthTokenType[AuthTokenType["ClientAssertion"] = 3] = "ClientAssertion";
    AuthTokenType[AuthTokenType["ClientAssertionV2"] = 4] = "ClientAssertionV2";
    AuthTokenType[AuthTokenType["AutoClpLowPrivilege"] = 5] = "AutoClpLowPrivilege";
    AuthTokenType[AuthTokenType["AutoClpAppOnlyLowPrivilege"] = 6] = "AutoClpAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["Substrate"] = 7] = "Substrate";
    AuthTokenType[AuthTokenType["WacUserInfo"] = 8] = "WacUserInfo";
    AuthTokenType[AuthTokenType["OwaExchange"] = 9] = "OwaExchange";
    AuthTokenType[AuthTokenType["SmartCompose"] = 10] = "SmartCompose";
    AuthTokenType[AuthTokenType["WritingAnalyticsLowPrivilege"] = 11] = "WritingAnalyticsLowPrivilege";
    AuthTokenType[AuthTokenType["DWEngineLowPrivilege"] = 12] = "DWEngineLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateApp"] = 13] = "SubstrateApp";
    AuthTokenType[AuthTokenType["CortanaAppPop"] = 14] = "CortanaAppPop";
    AuthTokenType[AuthTokenType["OfficeAppsAppOnly"] = 15] = "OfficeAppsAppOnly";
    AuthTokenType[AuthTokenType["PPTFrontdoorAppPop"] = 16] = "PPTFrontdoorAppPop";
    AuthTokenType[AuthTokenType["EditorAppOnlyLowPrivilege"] = 17] = "EditorAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopApp"] = 18] = "AugLoopApp";
    AuthTokenType[AuthTokenType["MeetingIntelligenceApp"] = 19] = "MeetingIntelligenceApp";
    AuthTokenType[AuthTokenType["GraphApp"] = 20] = "GraphApp";
    AuthTokenType[AuthTokenType["IceServicesApp"] = 21] = "IceServicesApp";
    AuthTokenType[AuthTokenType["AzureMapsApp"] = 22] = "AzureMapsApp";
})(AuthTokenType || (AuthTokenType = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["Unknown"] = 0] = "Unknown";
    UserType[UserType["Consumer"] = 1] = "Consumer";
    UserType[UserType["Enterprise"] = 2] = "Enterprise";
})(UserType || (UserType = {}));
//# sourceMappingURL=authTypes.js.map